import { useRef } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Legend } from '../../../../../common/chart/legend'
import { PieChartContainer } from '../../../../../common/chart/pieChart'
import { UseI18n } from '../../../../../common/hooks/useI18n'
import { getUnique } from '../../../../../helpers/common'
import { dataChartAlert } from '../../store/slice'

export const ChartTotalAlert = () => {
  const chartId = useRef(getUnique())

  const data = useSelector(dataChartAlert)

  const legendItems = data.map((item, index) => ({
    title: UseI18n(`dashboard.totalAlert.${item.name}`),
    value: item?.value,
    color: item?.color,
    pieIndex: index,
  }))

  //Actions
  const formatNameTooltip = (_, { activeData }) => {
    return <Translate value={`dashboard.totalAlert.${activeData.name}`} />
  }

  const formatValueTooltip = (_, { activeData }) => {
    return `${activeData.value}/${activeData.total}`
  }

  return (
    <div className="dFlex gap2 w100">
      <div style={{ minWidth: 130 }} className="w40 dFlex justifyContentEnd">
        <PieChartContainer
          chartId={chartId.current}
          data={data}
          width={130}
          height={130}
          innerRadius={34}
          isTooltipActive={true}
          formatNameTooltip={formatNameTooltip}
          formatValueTooltip={formatValueTooltip}
          isLabelActive={false}
        />
      </div>
      <div style={{ paddingTop: 8 }} className="flex1s">
        <Legend
          chartId={chartId.current}
          items={legendItems}
          className="flexColumn"
        />
      </div>
    </div>
  )
}
